import React from 'react'
import PropTypes from 'prop-types'
import { TextInput, Select } from 'advenio-components'
import { Col, FormContainer, Grid, Header, Row } from './ParentProfileForm'

const InvoiceDataForm = ({ info , regimenOtions, usoCFDIOptions, changeUsoCFDI }) => (
  <FormContainer>
    <Header>Datos de Facturación</Header>
    <Grid>
      <Row>
        <Col sm={6} md={3}>
          <TextInput
            name="tax_info.name"
            label="Nombre"
            value={info && info.name}
          />
        </Col>
        <Col sm={6} md={3}>
          <TextInput
            name="tax_info.rfc"
            label="RFC"
            value={info && info.rfc}
          />
        </Col>
        <Col sm={6} md={3}>
          <Select
            name="tax_info.uso_cfdi_id"
            label="Uso CFDI"
            value={info && info.uso_cfdi_id}
            placeholder="Seleccione Uso CFDI"
            options={usoCFDIOptions}
            onChangeCallback={(e)=>{changeUsoCFDI(e)}}
          />
        </Col>
        <Col sm={6} md={3}>
          <Select
            name="tax_info.regimen_fiscal"
            label="Regimen Fiscal"
            value={info && info.regimen_fiscal}
            // placeholder="Seleccione Regimen fiscal"
            options={regimenOtions}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={6}>
          <TextInput
            name="tax_info.address_1"
            label="Dirección 1"
            value={info && info.address_1}
          />
        </Col>
        <Col sm={6} md={6}>
          <TextInput
            name="tax_info.address_2"
            label="Dirección 2"
            value={info && info.address_2}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={3}>
          <TextInput
            name="tax_info.address_locality"
            label="Municipio"
            value={info && info.address_locality}
          />
        </Col>
        <Col sm={6} md={3}>
          <TextInput
            name="tax_info.address_state"
            label="Estado"
            value={info && info.address_state}
          />
        </Col>
        <Col sm={6} md={3}>
          <TextInput
            name="tax_info.address_country"
            label="País"
            value={info && info.address_country}
          />
        </Col>
        <Col sm={6} md={3}>
          <TextInput
            name="tax_info.address_postcode"
            label="Código Postal"
            value={info && info.address_postcode}
          />
        </Col>
      </Row>
    </Grid>
  </FormContainer>
)

InvoiceDataForm.propTypes = {
  /** An array with the parent's tax information */
  info: PropTypes.shape({
    /** The name used on any invoices generated for this parent */
    name: PropTypes.string,
    /** The tax identification number (e.g. RFC in Mexico) */
    rfc: PropTypes.string,
    /** The first line of the parent's address used for tax purposes */
    address_1: PropTypes.string,
    /** The second line of the parent's address used for tax purposes */
    address_2: PropTypes.string,
    /** The city/municipality of the parent's address used for tax purposes */
    address_locality: PropTypes.string,
    /** The state of the parent's address used for tax purposes */
    address_state: PropTypes.string,
    /** The country of the parent's address used for tax purposes */
    address_country: PropTypes.string,
    /** The postcode of the parent's address used for tax purposes */
    address_postcode: PropTypes.string,
  }),
}

InvoiceDataForm.defaultProps = {
  info: {
    name: '',
    rfc: '',
    address_1: '',
    address_2: '',
    address_locality: '',
    address_state: '',
    address_country: '',
    address_postcode: '',
  },
}

export default InvoiceDataForm



// WEBPACK FOOTER //
// ./src/Components/ParentComponents/InvoiceDataForm.jsx